/** `/mix` マウント全体の表示名。特定の板名に紐づけない固定文言。 */
export const MIX_MOUNT_DISPLAY_NAME = "総合＠あいもげ";

/**
 * 表示名を出す面。
 *
 * - `mount`: マウント全体を指す面(カタログ・リスト・設定など)。mixでは総合名。
 * - `board`: 個別板を指す面(スレページ)。mixでも `{板名}@あいもげ` を出す。
 */
export type BoardDisplaySurface = "mount" | "board";

type BoardDisplayNameSource = Readonly<{
  boardName: string;
  /**
   * `/mix` マウントの判別子(`BoardRuntimeConfig.mix`)。存在し、かつ面が
   * `mount` のときだけ総合カタログ全体の表示名を使う。個別板名を出したい
   * 呼び出し元は、この項目を持たないオブジェクトを渡すか `board` を指定する。
   */
  mix?: unknown;
}>;

export function formatBoardDisplayName(
  config: BoardDisplayNameSource,
  surface: BoardDisplaySurface = "mount",
): string {
  return config.mix !== undefined && surface === "mount"
    ? MIX_MOUNT_DISPLAY_NAME
    : `${config.boardName}@あいもげ`;
}
